import React from "react";
import "./ScheduleCard.css";
import { showDate } from "../../../../utils/dateUtils";
import { useMatchesStore } from "../../../../store/matchesStore";
import { Button } from "../../../catalyst/button";

interface ScheduleCardProps {
  entry: any;
  onMatchSetup?: (entry: any) => void;
}

export const ScheduleCard: React.FC<ScheduleCardProps> = ({
  entry,
  onMatchSetup,
}) => {
  const { allMatches } = useMatchesStore();

  return (
    <div
      className={`schedule-card ${
        entry.groupOrKnockout === "Knock-out" ? "knockout-card" : ""
      } ${entry.isFinals ? "finals-card" : ""}`}
    >
      <div className="card-header">
        <span className="serial-number">#{entry.order}</span>
        <span className="stage-badge">{entry.groupOrKnockout}</span>
      </div>
      <div className="card-grid">
        <div className="card-item">
          <span className="label">Date:</span>
          <span className="value">{showDate(entry.date)}</span>
        </div>
        <div className="card-item">
          <span className="label">Format:</span>
          <span className="value">{entry.matchType}</span>
        </div>
        <div className="card-item">
          <span className="label">Venue:</span>
          <span className="value">{entry.location}</span>
        </div>
        <div className="card-item">
          <span className="label">Tee Off:</span>
          <span className="value">
            {entry.teeOff}

            {onMatchSetup && allMatches &&
              allMatches.map((match) => {
                if (match.matchId === entry.id && match.allowPlayerSelections) {
                  return (
                    <Button
                      key={entry.id}
                      color="emerald"
                      onClick={() => onMatchSetup(entry)}
                      className="h-7"
                    >
                      Setup Players
                    </Button>
                  );
                }
              })}
          </span>
        </div>
      </div>
    </div>
  );
};
